<mat-card class="widget">
  <mat-toolbar color="primary">
    <p class="fs-16">{{ "tile.prescriptions" | translate }}</p>
    <span class="spacerBetween"></span>
    <ng-container [ngTemplateOutlet]="datePickers" *ngIf="!isMobile"></ng-container>

    <app-widget-actions
      *ngIf="actions?.length"
      [actions]="actions"
      [isMobile]="responsiveService.isHandset$ | async"
      (actionTriggered)="handleAction($event.action, $event.event)"
    ></app-widget-actions>
  </mat-toolbar>
  <div class="mini-bar" *ngIf="isMobile">
    <ng-container [ngTemplateOutlet]="datePickers"></ng-container>
  </div>
  <mat-card-content>
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="center" (selectedTabChange)="tabChanged()">
      <mat-tab [label]="'tile.prescriptions' | translate">
        <mat-list class="p-0" [ngStyle]="isLoading ? { display: 'none' } : {}">
          <mat-list-item *ngFor="let element of dataSource.rawData$ | async">
            <div class="prescriptionsInfo">
              <div>{{ element.category | translate }}</div>
              <div>{{ element.dateRequest | safeDate : "dd/MM/yyyy HH:mm" }}</div>
              <div>{{ "table.status" | translate }} : {{ "prescription.status." + element.status | translate }}</div>
            </div>

            <button
              *ngIf="element.status === 0"
              mat-icon-button
              class="custom-icon-w"
              color="primary"
              (click)="validatePrescription(element)"
            >
              <mat-icon class="custom-icon-small warn">task_alt</mat-icon>
            </button>
          </mat-list-item>
        </mat-list>
        <p class="pt-05 pb-05" *ngIf="!(dataSource.rawData$ | async)?.length && !isLoading">
          {{ "widget.noData" | translate }}
        </p>
      </mat-tab>
      <mat-tab [label]="'page.invoices.title' | translate">
        <mat-table [dataSource]="dataSource.rawData$ | async" *ngIf="(dataSource.rawData$ | async)?.length">
          <ng-container matColumnDef="category">
            <mat-header-cell *matHeaderCellDef>{{ "table.category" | translate }} </mat-header-cell>
            <mat-cell *matCellDef="let element"
              ><span>{{ element.prescription.category | translate }}</span></mat-cell
            >
          </ng-container>
          <ng-container matColumnDef="code">
            <mat-header-cell *matHeaderCellDef>{{ "table.code" | translate }} </mat-header-cell>
            <mat-cell *matCellDef="let element"
              ><span>{{ element.code }}</span></mat-cell
            >
          </ng-container>
          <ng-container matColumnDef="startDate">
            <mat-header-cell *matHeaderCellDef>{{ "schedule.from" | translate }} </mat-header-cell>
            <mat-cell *matCellDef="let element"
              ><span>{{ element.startDate | safeDate }}</span></mat-cell
            >
          </ng-container>
          <ng-container matColumnDef="endDate">
            <mat-header-cell *matHeaderCellDef>{{ "schedule.to" | translate }} </mat-header-cell>
            <mat-cell *matCellDef="let element"
              ><span>{{ element.endDate | safeDate }}</span></mat-cell
            >
          </ng-container>
          <ng-container matColumnDef="amount">
            <mat-header-cell *matHeaderCellDef>{{ "table.amount" | translate }} </mat-header-cell>
            <mat-cell *matCellDef="let element"
              ><span>{{ element.totalPrice }}</span></mat-cell
            >
          </ng-container>
          <ng-container matColumnDef="status">
            <mat-header-cell *matHeaderCellDef>{{ "table.status" | translate }} </mat-header-cell>
            <mat-cell *matCellDef="let element"
              ><span>{{ "billing.status." + element.status | translate }}</span></mat-cell
            >
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns" (click)="goToBillingPage(row)"></mat-row>
        </mat-table>
        <p class="pt-05 pb-05" *ngIf="!(dataSource.rawData$ | async)?.length && !isLoading">
          {{ "widget.noData" | translate }}
        </p>
      </mat-tab>
    </mat-tab-group>
    <div class="spinner-container" *ngIf="(dataSource.loading$ | async) || isLoading">
      <mat-spinner></mat-spinner>
    </div>
    <mat-paginator
      #paginator
      [pageIndex]="0"
      [pageSize]="currentPageSize"
      [length]="prescriptionsCount"
      [hidePageSize]="true"
      [ngClass]="{ hide: dataSource.data.length === 0 && isLoading }"
    ></mat-paginator>
  </mat-card-content>
</mat-card>
<ng-template #datePickers>
  <form [formGroup]="filterFormTable" style="min-width: 0">
    <div class="datePickerContainer ml-5">
      <mat-form-field class="datePickerField ml-5">
        <input
          cdkFocusInitial
          matInput
          [matDatepicker]="fromDateTable"
          formControlName="fromDate"
          placeholder="{{ 'itemFilter.fromDate' | translate }}"
        />
        <mat-datepicker-toggle matSuffix [for]="fromDateTable"></mat-datepicker-toggle>
        <mat-datepicker #fromDateTable></mat-datepicker>
      </mat-form-field>
    </div>
  </form>
</ng-template>
